<template>
  <v-row justify="center">
    <v-dialog v-model="openDialog" persistent max-width="800px">
      <v-card v-if="coupon">
        <v-card-title class="mx-3 pl-6 pt-4">
          <span v-if="mode === 'edit'" class="text-h5"
            >Gutschein bearbeiten</span
          >
          <span v-else class="text-h5">Neuen Gutschein erstellen</span>
        </v-card-title>
        <v-divider class="mx-9" />
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :disabled="mode === 'edit'"
                    bg-color="accent"
                    variant="filled"
                    hide-details="auto"
                    label="Gutscheinnummer"
                    v-model="selectedCoupon.id"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details="auto"
                    label="Bezeichnung"
                    v-model="selectedCoupon.description"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details="auto"
                    type="number"
                    hide-spin-buttons
                    label="maximale Anzahl"
                    v-model="selectedCoupon.maxAmount"
                    :rules="[rules.required, rules.isPositiveNumber]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select
                    bg-color="accent"
                    variant="filled"
                    label="Typ"
                    :items="couponTypes"
                    v-model="selectedCoupon.type"
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    bg-color="accent"
                    variant="filled"
                    hide-details="auto"
                    type="number"
                    hide-spin-buttons
                    label="Wert"
                    :rules="
                      selectedCoupon.type === 'percentage'
                        ? [
                            rules.required,
                            rules.isPositiveNumber,
                            rules.maxPercentageLimit,
                          ]
                        : [rules.required, rules.isPositiveNumber]
                    "
                    v-model="selectedCoupon.discount"
                  >
                    <template #append-inner>
                      {{ selectedCoupon.type === "percentage" ? "%" : "€" }}
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-10">
                <v-col cols="12">
                  <p class="text-uppercase">
                    <strong>Gültig ab</strong>
                  </p>
                </v-col>
                <v-col class="mr-5 mt-3">
                  <v-dialog
                    ref="validFromDialog"
                    v-model="validFromModal"
                    persistent
                    :return-value.sync="validDateFrom"
                    width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="validDateFrom"
                        label="Gültig ab"
                        prepend-icon="mdi-calendar"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="validFromModal = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="validDateFrom" hide-title scrollable>
                      <template #actions>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validDateFrom = null;
                            validFromModal = false;
                          "
                          >Löschen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validDateFrom = validDateFromTemp;
                            validFromModal = false;
                          "
                          >Abbrechen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="validFromModal = false"
                          >Speichern</v-btn
                        >
                      </template>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col class="mt-3">
                  <v-dialog
                    ref="validTimeFromDialog"
                    v-model="validTimeFromModal"
                    persistent
                    :return-value.sync="validTimeFrom"
                    width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="validTimeFrom"
                        label="Uhrzeit"
                        prepend-icon="mdi-clock-time-four-outline"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="validTimeFromModal = true"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="validTimeFrom"
                      full-width
                      format="24hr"
                    >
                      <template #actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validTimeFrom = null;
                            validTimeFromModal = false;
                          "
                          >Löschen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validTimeFrom = validTimeFromTemp;
                            validTimeFromModal = false;
                          "
                          >Abbrechen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="validTimeFromModal = false"
                          >Speichern</v-btn
                        >
                      </template>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <p class="text-uppercase">
                    <strong>Gültig bis</strong>
                  </p>
                </v-col>
                <v-col class="mr-5 mt-3">
                  <v-dialog
                    ref="validToDialog"
                    v-model="validToModal"
                    persistent
                    :return-value.sync="validDateTo"
                    width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="validDateTo"
                        label="Datum"
                        prepend-icon="mdi-calendar"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="validToModal = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="validDateTo" hide-title scrollable>
                      <template #actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validDateTo = null;
                            validToModal = false;
                          "
                          >Löschen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validDateTo = validDateToTemp;
                            validToModal = false;
                          "
                          >Abbrechen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="validToModal = false"
                          >Speichern</v-btn
                        >
                      </template>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col class="mt-3">
                  <v-dialog
                    ref="validTimeToDialog"
                    v-model="validTimeToModal"
                    persistent
                    :return-value.sync="validTimeTo"
                    width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="validTimeTo"
                        label="Uhrzeit"
                        prepend-icon="mdi-clock-time-four-outline"
                        bg-color="accent"
                        variant="filled"
                        readonly
                        v-bind="props"
                        @click:prepend-icon="validTimeToModal = true"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="validTimeTo"
                      full-width
                      format="24hr"
                    >
                      <template #actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validTimeTo = null;
                            validTimeToModal = false;
                          "
                          >Löschen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="
                            validTimeTo = validTimeToTemp;
                            validTimeToModal = false;
                          "
                          >Abbrechen</v-btn
                        >
                        <v-btn
                          variant="text"
                          color="primary"
                          @click="validTimeToModal = false"
                          >Speichern</v-btn
                        >
                      </template>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="mb-5"
            color="primary"
            variant="flat"
            @click="submitChanges"
            :loading="inProgress"
          >
            Speichern
          </v-btn>
          <v-btn class="mb-5 mr-5" variant="outlined" @click="closeDialog">
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ApiCouponService from "@/services/api/ApiCouponService";
import { mapActions, mapGetters } from "vuex";
import ToastService from "@/services/ToastService";

export default {
  name: "CouponEdit",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      require: true,
    },
    coupon: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      validFromModal: false,
      validTimeToModal: false,
      validTimeFromModal: false,
      validToModal: false,
      inProgress: false,
      validDateFrom: null,
      validDateFromTemp: null,
      validDateTo: null,
      validDateToTemp: null,
      validTimeFrom: null,
      validTimeFromTemp: null,
      validTimeTo: null,
      validTimeToTemp: null,
      valid: true,
      rules: {
        required: (value) => !!value || "Pflichtfeld",
        isPositiveNumber: (v) =>
          parseFloat(v) >= 0 || "Nur positive Werte erlaubt",
        maxPercentageLimit: (v) =>
          parseFloat(v) <= 100 ||
          "Der Höchstwert für den Prozentsatz beträgt 100",
      },
      couponTypes: [
        { title: "Prozent", value: "percentage" },
        { title: "Betrag", value: "fixed" },
      ],
    };
  },
  computed: {
    ...mapGetters({ tenantId: "tenants/currentTenantId" }),
    openDialog: {
      get() {
        return this.open;
      },
    },
    selectedCoupon: {
      get() {
        return this.coupon;
      },
    },
  },
  methods: {
    ...mapActions({
      addToast: "toasts/add",
    }),
    closeDialog() {
      this.$emit("close");
    },
    async submitChanges() {
      const result = await this.$refs.form.validate();
      if (result.valid) {
        this.inProgress = true;

        if (this.validDateFrom) {
          this.selectedCoupon.validFrom = this.transformDateTime(
            this.validDateFrom,
            this.validTimeFrom
          );
        } else {
          this.selectedCoupon.validFrom = null;
        }

        if (this.validDateTo) {
          this.selectedCoupon.validTo = this.transformDateTime(
            this.validDateTo,
            this.validTimeTo
          );
        } else {
          this.selectedCoupon.validTo = null;
        }

        this.selectedCoupon.tenantId = this.tenantId;

        await ApiCouponService.submitCoupon(undefined, this.selectedCoupon)
          .then((response) => {
            this.inProgress = false;
            this.$emit("close");
          })
          .catch((error) => {
            this.addToast(
              ToastService.createToast("coupon.create.error", "error")
            );
            this.inProgress = false;
          });
      } else {
        //reset validation after 4 seconds
        setTimeout(() => {
          this.$refs.form?.resetValidation();
        }, 4000);
      }
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    formatDate(date) {
      if (date !== "Invalid Date" && date) {
        return [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
        ].join("-");
      } else {
        return null;
      }
    },
    formatTime(date) {
      if (date !== "Invalid Date" && date) {
        return [
          this.padTo2Digits(date.getHours()),
          this.padTo2Digits(date.getMinutes()),
        ].join(":");
      } else {
        return null;
      }
    },
    transformDateTime(date, time) {
      if (!date) {
        return null;
      }

      // the time zone should germany

      const timestamp = new Date(date).getTime();
      const dateObj = new Date(timestamp);

      if (time) {
        const [hours, minutes] = time.split(":");
        dateObj.setHours(hours, minutes, 0, 0);
      } else {
        dateObj.setHours(0, 0, 0, 0);
      }

      return dateObj.getTime();
    },
  },
  watch: {
    openDialog(val) {
      if (val) {
        this.$refs.form?.resetValidation();
      }
    },
    validFromModal: function () {
      this.validDateFromTemp = this.validDateFrom;
    },
    validTimeFromModal: function () {
      this.validTimeFromTemp = this.validTimeFrom;
    },
    validToModal: function () {
      this.validDateToTemp = this.validDateTo;
    },
    validTimeToModal: function () {
      this.validTimeToTemp = this.validTimeTo;
    },
    coupon: {
      handler() {
        if (this.coupon.validFrom) {
          this.validDateFrom = this.formatDate(new Date(this.coupon.validFrom));
          this.validTimeFrom = this.formatTime(new Date(this.coupon.validFrom));
        } else {
          this.validDateFrom = null;
          this.validTimeFrom = null;
        }
        if (this.coupon.validTo) {
          this.validDateTo = this.formatDate(new Date(this.coupon.validTo));
          this.validTimeTo = this.formatTime(new Date(this.coupon.validTo));
        } else {
          this.validDateTo = null;
          this.validTimeTo = null;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
